<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getTransfersHeaders()"
    :items="transfers"
    :loading="loadingTransfers"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions>
    <template v-slot:headers="props">
      <tr>
        <th
          v-for="header in props.headers"
          :key="header.text"
          :class="[header.sortable ? 'column sortable': '', pagination.descending ? 'desc' : 'acs', header.value === pagination.sortBy ? 'active' : '']"
          class="subheading font-weight-light krita-dark text--darken-3"
          @click="changeSort(header.value,header.sortable)">
          <v-icon
            v-if="header.sortable"
            small>arrow_upward</v-icon>
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <td class="text-xs-left">{{ props.item.BatchTransferId }}</td>
      <td class="text-xs-left">{{ props.item.Amount | amount }}</td>
      <td class="text-xs-left">{{ props.item.TransferedDate | date }}</td>
      <td class="text-xs-left">{{ props.item.TransferTrigger }}</td>
      <td class="text-xs-right">{{ props.item.Status }}</td>
      <td class="text-xs-right">{{ props.item.Created | date }}</td>
    </template>
  </v-data-table>
</template>

<script>
    export default {
        name: "FactoringDetailTransfersDatagrid",
      // eslint-disable-next-line vue/require-prop-types
        props: ['loadingTransfers','transfers'],
        data () {
          return {
            pagination:
                    {
                      sortBy: 'id'
                    }
          }
        },
        methods: {
            getTransfersHeaders()
            {
                return [
                    {sortable: true, text: this.$t('krita.factoring.batchid'), value: 'batchId', align: 'left'},
                    {sortable: true, text: this.$t('krita.amount'), value: 'amount', align: 'left'},
                    {sortable: true, text: this.$t('krita.factoring.date'), value: 'date', align: 'left'},
                    {sortable: true, text: this.$t('krita.factoring.transfertrigger'), value: 'transferTrigger', align: 'left'},
                    {sortable: true, text: this.$t('krita.status'), value: 'status', align: 'right'},
                    {sortable: true, text: this.$t('krita.factoring.created'), value: 'created', align: 'right'}
                ]
            },
            changeSort (sort)
            {
              let self = this;

              self.pagination.sortBy = sort.sortBy;
              self.pagination.descending = sort.descending;
              self.$emit('refreshWithSort',self.pagination);
            }
        }
    }
</script>

<style scoped>

</style>
